import { render, staticRenderFns } from "./ImageSelector.vue?vue&type=template&id=589cbd70&scoped=true"
import script from "./ImageSelector.vue?vue&type=script&lang=js"
export * from "./ImageSelector.vue?vue&type=script&lang=js"
import style0 from "./ImageSelector.vue?vue&type=style&index=0&id=589cbd70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589cbd70",
  null
  
)

export default component.exports